import {
  Result,
  RESULT_VARIANT_WARNING,
} from '@sgcmpteltd/uikit-react/components/result';
import cx from 'clsx';

import styles from './styles.module.scss';
import type { Component } from './types';

export const ErrorStep: Component = ({
  className,
}) => (
  <div
    className={cx(
      styles.containerRoot,
      className,
    )}>
    <div
      className={styles.containerResult}>
      <Result
        message="Make sure your internet is working, or just try again later."
        title="Something Went Wrong"
        variant={RESULT_VARIANT_WARNING} />
    </div>
  </div>
);
